import { Injectable } from '@angular/core'
import { environment } from 'apps/shop/src/environments/environment'

export interface Theme { color: string, displayName: string, name: string, background: string, isDefault?: boolean,dark?: boolean}

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {

    apiBaseUrl(){
        const url = environment.production ? environment.apiBaseUrl : location.origin.split(':4200').join(':3000');
        return url;
    }

}
